import { render } from "./LoadingSpinner.vue?vue&type=template&id=6f575575&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=6f575575&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f575575"]])

export default __exports__